import { render, staticRenderFns } from "./Loginold.vue?vue&type=template&id=03f21ff7&scoped=true"
import script from "./Loginold.vue?vue&type=script&lang=js"
export * from "./Loginold.vue?vue&type=script&lang=js"
import style0 from "./Loginold.vue?vue&type=style&index=0&id=03f21ff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f21ff7",
  null
  
)

export default component.exports